<div class="page-header-inner">
    <a *ngIf="backRouterLink"
       [cllTooltip]="backLinkTooltip"
       [routerLink]="backRouterLink"
       cll-icon-button>
        <mat-icon>chevron_left</mat-icon>
    </a>

    <ng-content select="app-avatar[appPageHeaderAvatar]"></ng-content>
    <ng-content select="mat-icon[appPageHeaderIcon],cll-icon[appPageHeaderIcon],img[appPageHeaderIcon]"></ng-content>

    <div class="app-page-header-headings"
         data-testid="header:page">
        <h2>
            <ng-content select="app-page-header-title"></ng-content>
        </h2>

        <ng-content select="app-page-header-subtitle"></ng-content>
    </div>

    <ng-content select="nav"></ng-content>
</div>

<ng-content select="app-page-header-info"></ng-content>

<ng-container *ngIf="showFilters">
    <ng-content select="app-filter"></ng-content>
</ng-container>
